import VizExLoadingSpinner from 'visitor-ui-component-library/loading/VizExLoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LoadingState() {
  return /*#__PURE__*/_jsx(VizExLoadingSpinner, {
    grow: true
  });
}
LoadingState.displayName = 'LoadingState';